import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { store } from "../../store";
import { setShowAuthModal } from "../../store/modules/auth/actions";


const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  // Do something before request is sent
  // console.info(`[request]:: `, config);
  return config;
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  // Do something with request error
  console.error(`Erro na requisição da API:: `, error);
  return Promise.reject(error);
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data

  if(response.data.hasError) {
    console.error(`Erro na resposta da API:: `, response);
    if(typeof response.data?.messages === 'string') {
      toast.warning(`- ${response.data?.messages}`, { autoClose: 15000 });
      return response;
    }
    const { messages } = response.data;
    if(messages && typeof messages === 'object' && Array.isArray(messages) && messages?.length > 0) {
      response.data?.messages.forEach((message: string) => {
        toast.warning(message, { autoClose: 15000 });
      });
    }
  }
  return response;
}

const onResponseError = (axiosError: AxiosError): Promise<AxiosError> => {
  // const history = useHistory();
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log('axiosError.response:: ', axiosError.response)
  if(!!axiosError.response?.data) {
    const { error, message, statusCode } = axiosError.response?.data
    switch(statusCode) {
      case 400: {
        console.group('Campo(s) obrigatório(s):');
        message.forEach((error: string) => {
          console.error(error);
        });
        console.groupEnd();
        break;
      }
      case 401: {
        console.error(`Erro[${statusCode}] Falha na autenticação. `);
        if(axiosError.response?.config.url === '/api/auth/signin') {
          toast.error('Credenciais inválidas', { autoClose: 10000 });
          break;
        }
        store.dispatch(setShowAuthModal({ showAuthModal: true }));
        break;
      }
      default: {
        console.error(`Erro[${statusCode}]:: `, axiosError.response?.data);
        toast.error(message, { autoClose: 15000 });
        break;
      }
    }
    if(message && typeof message === 'object' && Array.isArray(message) && message?.length > 0) {
      message.forEach((msg: string) => {
        toast.warning(msg, { autoClose: 15000 });
      });
    }
  }
  return Promise.reject(axiosError);
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
